import React from 'react'
import { useRouter } from 'next/router'
import { jsonToArray } from '@helpers/contentful'
import { BadgeProps } from '@components/ui/Badge'
import styles from './styles.module.scss'
import { NavigationLink } from './NavigationLink'

const getNavFromCollectionHandle = (
  navs: CollectionMenuLinksProps['navigationLinks'],
  collectionHandle: string
) =>
  navs?.find(
    nav =>
      jsonToArray(nav).findIndex(
        handle => handle.handle === `/collections/${collectionHandle}`
      ) > -1
  ) || { title: undefined }

export type CollectionMenuLinksProps = {
  navigationLinks: {
    title: string
    handle: string
    badge?: BadgeProps
  }[]
}

export const CollectionMenuLinks = ({
  navigationLinks
}: CollectionMenuLinksProps) => {
  const router = useRouter()
  const { collectionHandle } = router.query as { collectionHandle: string }

  if (navigationLinks.length === 0) {
    return null
  }

  const mainLinkTitle = getNavFromCollectionHandle(
    navigationLinks,
    collectionHandle
  ).title

  return (
    <>
      <div
        className={styles.CollectionMenuNav}
        data-testid="product-navigation"
      >
        <div className={styles.CollectionMenuNav__container}>
          {navigationLinks.map((link, index) => {
            return (
              <NavigationLink
                key={link.title}
                url={link.handle}
                title={`${index === 0 ? `All ${link.title}` : link.title}`}
                isActive={
                  `/collections/${collectionHandle}` === link.handle ||
                  link.title === mainLinkTitle
                }
              />
            )
          })}
        </div>
      </div>
    </>
  )
}
